// Domain constants for the audience feature (extracted from email's
// useJwtToken and billing plan.types so the package carries no app imports).
export const FETCH_AND_SEND_TRAFFIC_SHAPING =
  "FETCH_AND_SEND_WITH_TRAFFIC_SHAPING";

export enum PlanCodes {
  ShopifyPro = "SHOPIFY_FREE",
  Pro = "pro",
  Standard = "growth",
  Free = "free_forever",
  GroovePro = "groove_pro",
  GrooveFree = "groove_free",
}

export enum AppSumoPlanCodes {
  LicenceTier1 = "tinyemail_tier1",
  LicenceTier2 = "tinyemail_tier2",
  LicenceTier3 = "tinyemail_tier3",
  LicenceTier4 = "tinyemail_tier4",
}
